const [d] = [document];

export class eventBlock {

  constructor () {
    this.render();
  }

  render () {
    const getArticles = this.fetchArticles({
      content: 'topics',
      post_per_page: 3,
      category_in: 3
    });
    const getCategories = this.fetchCategories('topics');
    const dispTags = tags => {
      tags = tags.map(t => `<span class="tag">#${t}</span>`);
      return `<span class="tags">${tags.join('')}</span>`;
    };

    const appendList = (item) => {
      $('.case-event__list').append(`
      <li>
        <a href="${item.href}">
          <figure><img src="${item.thumb}" alt="${item.title}"></figure>
          <p>${item.title}</p>
        </a>
      </li>
      `);
    }

    Promise.all([getArticles,getCategories]).then( ([articles,cats]) => {
      d.querySelector('.case-event__list').innerHTML = '';
      articles.map( article => {
        article.category = cats.find( v => v.id == article.category ) || {id: '0', href: '/topics/?mode=list&cat=0', name: 'その他', turn: 99};
        appendList(article);
      });
    });
  }

  fetchCategories (content) {
    return fetch(`/asset/api/getCategories/?content=${content}`)
      .then(r => r.json())
      .catch(e => { throw new Error(e)});
  }

  fetchArticles (opt){
    return fetch(`/asset/api/getArticles/?${ new URLSearchParams(opt)}`)
    .then(r => r.json())
    .catch(e => { throw new Error(e)});
  }
}